"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CameraPlaneConstraint_dragOrigin, _CameraPlaneConstraint_dragPlane, _CameraPlaneConstraint_rotation;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraPlaneConstraint = void 0;
const gl_matrix_1 = require("gl-matrix");
const viewer_shared_math_1 = require("@shapediver/viewer.shared.math");
const InteractionData_1 = require("../InteractionData");
const DragConstraintsHelper_1 = require("./DragConstraintsHelper");
class CameraPlaneConstraint {
    // #endregion Properties (3)
    // #region Constructors (1)
    constructor(_rotation) {
        // #region Properties (3)
        _CameraPlaneConstraint_dragOrigin.set(this, void 0);
        _CameraPlaneConstraint_dragPlane.set(this, void 0);
        _CameraPlaneConstraint_rotation.set(this, void 0);
        __classPrivateFieldSet(this, _CameraPlaneConstraint_rotation, _rotation || { axis: gl_matrix_1.vec3.fromValues(0, 0, 1), angle: 0 }, "f");
    }
    // #endregion Constructors (1)
    // #region Public Methods (2)
    intersect(viewer, node, ray) {
        var _a;
        const distance = (_a = __classPrivateFieldGet(this, _CameraPlaneConstraint_dragPlane, "f")) === null || _a === void 0 ? void 0 : _a.intersect(ray.origin, ray.direction);
        if (distance && distance > 0) {
            const point = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), ray.direction, gl_matrix_1.vec3.fromValues(distance, distance, distance)), ray.origin);
            return { distance, transformation: DragConstraintsHelper_1.calculateDragMatrix(node, point, __classPrivateFieldGet(this, _CameraPlaneConstraint_rotation, "f"), __classPrivateFieldGet(this, _CameraPlaneConstraint_dragOrigin, "f"), point) };
        }
        return;
    }
    setup(viewer, node, ray, intersection) {
        const cameraDirection = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), viewer.camera.target, viewer.camera.position));
        __classPrivateFieldSet(this, _CameraPlaneConstraint_dragPlane, new viewer_shared_math_1.Plane().setFromNormalAndCoplanarPoint(cameraDirection, intersection.point), "f");
        const data = node.data.find(d => d instanceof InteractionData_1.InteractionData);
        __classPrivateFieldSet(this, _CameraPlaneConstraint_dragOrigin, data && data.dragOrigin ? data.dragOrigin : intersection.point, "f");
        return this.intersect(viewer, node, ray);
    }
}
exports.CameraPlaneConstraint = CameraPlaneConstraint;
_CameraPlaneConstraint_dragOrigin = new WeakMap(), _CameraPlaneConstraint_dragPlane = new WeakMap(), _CameraPlaneConstraint_rotation = new WeakMap();
//# sourceMappingURL=CameraPlaneConstraint.js.map